import React, { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import EventIcon from "@mui/icons-material/Event";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import {
  displayDateFormat,
  downloadXLSXFile,
  getEndOfMonth,
  getFirstDateOfCurrentMonthPayloadFormate,
  getFirstDateOfMonth,
  getLastDateOfCurrentMonthPayloadFormat,
  getLastDateOfMonth,
  payloadDateFormat,
  Toast,
} from "../../utils/commonUtils";
import {
  Divider,
  FormControlLabel,
  Grid,
  Switch,
  TextField,
} from "@mui/material";
// import FileUploader from "./fileUploader";
// import { UpdateOffersApi } from "./UpdateOffersApi";
import { IconButton } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
// import FileUploader from "../offers/fileUploader";
import { UpdateOffersApi } from "../offers/UpdateOffersApi";
import FileUploader from "./FileUploader";
import { UpdateAdvertisementApi } from "./companyLoginApiHandler";

export default function UpdateAdvertisement({
  open,
  handleClose,
  offerData,
  value,
}) {
  console.log(offerData, "offerData ");
  const [SelectedEndDate, setSelectedEndDate] = useState(
    dayjs(getFirstDateOfMonth())
  );

  const [displayEndDate, setDisplayEndDate] = useState(displayDateFormat());

  const [SelectedStartDate, setSelectedStartDate] = useState(
    dayjs(getFirstDateOfMonth())
  );
  const [endDate, setEndDate] = useState(
    dayjs(getLastDateOfMonth()).format("YYYY-MM-DD")
  );
  const [startDateFormat, setstartDateFormat] = useState(
    dayjs(getFirstDateOfMonth()).format("YYYY-MM-DD")
  );
  console.log(startDateFormat, "endDateendDate");

  const datePickerRef2 = React.useRef();

  const [startDateOpen, setStartDateOpen] = useState(false);
  const [endDateOpen, setEndDateOpen] = useState(false);
  const datePickerOnChangeEnd = (date) => {
    setSelectedEndDate(date);

    const dateStr2 = date.toDate
      ? date.toDate().toLocaleDateString("en-GB", {
          year: "numeric",
          month: "long",
          day: "2-digit",
        })
      : date.format("DD-MMMM-YYYY");
    let dateContainer = String(dateStr2).split(" ");
    var year2 = dateContainer[2];
    var month2 = dateContainer[1];
    var day2 = dateContainer[0];
    var formattedDate2 = day2 + "-" + month2 + "-" + year2;
    setDisplayEndDate(formattedDate2);

    // Update endDate for API call
    setEndDate(date.format("YYYY-MM-DD"));
    setEndDateOpen(false);
  };

  const datePickerOnChange = (date) => {
    setSelectedStartDate(date);

    const dateStr2 = date.toDate
      ? date.toDate().toLocaleDateString("en-GB", {
          year: "numeric",
          month: "long",
          day: "2-digit",
        })
      : date.format("DD-MMMM-YYYY");
    let dateContainer = String(dateStr2).split(" ");
    var year2 = dateContainer[2];
    var month2 = dateContainer[1];
    var day2 = dateContainer[0];
    var formattedDate2 = day2 + "-" + month2 + "-" + year2;
    setStartDate(formattedDate2);

    // Update startDateFormat for API call
    setstartDateFormat(date.format("YYYY-MM-DD"));
    setStartDateOpen(false);
    setEndDateOpen(true);
  };

  const [startDate, setStartDate] = useState(displayDateFormat());
  const datePickerRef = useRef();

  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };
  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreviewUrl, setImagePreviewUrl] = useState("");
  const [message, setMessage] = useState("");
  const [checked, setChecked] = React.useState(true);
  const [status, setStatus] = useState("active");
  const handleChange = (event) => {
    const isChecked = event.target.checked;
    setChecked(isChecked);
    setStatus(isChecked ? "active" : "inactive");
  };

  useEffect(() => {
    // setMessage(offerData?.offerInformation);
    if (value === 0) {
      setImagePreviewUrl(offerData?.fileForWeb);
    } else {
      setImagePreviewUrl(offerData?.fileForAndroid);
    }
    if (offerData?.status == "active") {
      setChecked(true);
      setStatus("active");
    } else {
      setChecked(false);
      setStatus("inactive");
    }
    datePickerOnChange(dayjs(offerData?.fromDate.split("T")[0]));
    datePickerOnChangeEnd(dayjs(offerData?.toDate.split("T")[0]));
  }, [offerData]);

  const handleFileChange = (file) => {
    setSelectedFile(file);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      value === 0
        ? setImagePreviewUrl(offerData?.fileForWeb)
        : setImagePreviewUrl(offerData?.fileForAndroid);
    }
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append("Id", offerData?.id);
    // formData.append("OfferInformation", message);
    formData.append("FromDate", startDate);
    formData.append("ToDate", displayEndDate);
    formData.append("Status", status);
    // formData.append("File", selectedFile);
    if (selectedFile) {
      if (value === 0) {
        formData.append("FileForWeb", selectedFile);
      } else {
        formData.append("FileForAndroid", selectedFile);
      }
    }

    await UpdateAdvertisementApi(formData).then((res) => {
      if (res?.data?.succeeded) {
        Toast.fire({
          icon: "success",
          title: "Advertisement Updated succesfully.",
        });
        handleClose();
        setSelectedFile(null);
      } else {
        Toast.fire({
          icon: "error",
          title: "Something Went Wrong",
        });
      }
    });
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { lg: "30%", md: "35%", xs: "95%", sm: "60%" },
            bgcolor: "background.paper",
            boxShadow: 24,
            // p: 4,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              px: 2,
              py: 1,
              backgroundColor: "#CECEFF",
              boxShadow: 3,
            }}
          >
            <Typography color="#000" fontWeight={500} fontSize={17}>
              Update Advertisement
            </Typography>
            <IconButton onClick={() => handleClose(false)}>
              <CloseIcon sx={{ color: "#000" }} />
            </IconButton>
          </Box>
          <Box sx={{ px: 2, py: 1 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "right",
                mb: 1,
                mt: 2,
              }}
            >
              {/* <DatePicker
                hidden={true}
                selected={SelectedStartDate}
                maxDate={new Date()}
                onChange={datePickerOnChange}
                className="custom-datepicker"
                ref={datePickerRef}
                onClickOutside={() => {
                  datePickerRef.current.setOpen(false);
                }}
              />

              <DatePicker
                hidden={true}
                selected={SelectedEndDate}
                maxDate={new Date()}
                onChange={datePickerOnChangeEnd}
                className="custom-datepicker"
                ref={datePickerRef2}
                onClickOutside={() => {
                  datePickerRef2.current.setOpen(false);
                }}
              />
              <TextField
                fullWidth
                readonly
                size="small"
                onClick={openDatePicker}
                id="date"
                sx={{
                  mt: 2,
                }}
                value={startDate + " To " + displayEndDate}
                label={
                  <Box
                    sx={{
                      flex: 4,
                      color: "grey",
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                      color: "#01008B",
                    }}
                  >
                    Date :
                  </Box>
                }
                onChange={(e) => { }}
                InputProps={{
                  endAdornment: (
                    <EventIcon
                      sx={{
                        color: (theme) => theme.palette.primary.main,
                        cursor: "pointer",
                      }}
                    />
                  ),
                }}
              /> */}
              <TextField
                label="Date"
                size="small"
                value={
                  SelectedStartDate && SelectedEndDate
                    ? `${SelectedStartDate.format(
                        "DD-MM-YYYY"
                      )} to ${SelectedEndDate.format("DD-MM-YYYY")}`
                    : SelectedStartDate
                    ? `${SelectedStartDate.format("DD-MM-YYYY")}`
                    : ""
                }
                id="datepickerfield"
                placeholder="Select date range"
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <CalendarMonthIcon
                      sx={{
                        cursor: "pointer",
                        mr: 1,
                      }}
                      onClick={() => setStartDateOpen(true)} // trigger open
                    />
                  ),
                  sx: {
                    background: "#fff",
                    borderRadius: 1,
                    cursor: "pointer",
                    fontFamily: "'Montserrat', sans-serif",
                    fontWeight: 500,
                  },
                }}
                onClick={() => setStartDateOpen(true)} // trigger open
                sx={{ width: "100%", height: "50px" }}
              />

              <Box sx={{ position: "relative" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    open={startDateOpen}
                    onOpen={() => setStartDateOpen(true)}
                    onClose={() => setStartDateOpen(false)}
                    value={SelectedStartDate}
                    onChange={(val) => {
                      datePickerOnChange(val);
                    }}
                    maxDate={SelectedEndDate || undefined}
                    slotProps={{
                      popper: {
                        placement: "bottom-end",
                        anchorEl: document.querySelector("#datepickerfield"),
                        sx: { zIndex: 1500 },
                      },
                      textField: { style: { display: "none" } },
                    }}
                  />
                </LocalizationProvider>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    open={endDateOpen}
                    onOpen={() => setEndDateOpen(true)}
                    onClose={() => setEndDateOpen(false)}
                    value={SelectedEndDate}
                    onChange={(val) => {
                      datePickerOnChangeEnd(val);
                    }}
                    minDate={SelectedStartDate || undefined}
                    slotProps={{
                      popper: {
                        placement: "bottom-start",
                        anchorEl: document.querySelector("#datepickerfield"),
                        sx: { zIndex: 1500 },
                      },
                      textField: { style: { display: "none" } },
                    }}
                  />
                </LocalizationProvider>
              </Box>
            </Box>
            {/* <TextField
              onChange={(e) => setMessage(e.target.value)}
              sx={{ mb: 2 }}
              fullWidth
              label="Message"
              value={message}
              multiline
              rows={3}
              maxRows={5} // Grows up to 5 rows, and then it will scroll
              variant="outlined"
            /> */}
            <Box
              display={"flex"}
              sx={{ mb: 2 }}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Box display="flex" justifyContent="flex-start">
                    <FileUploader onFileSelect={handleFileChange} />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box
                    display="flex"
                    justifyContent="flex-end"
                    alignItems={"center"}
                  >
                    <FormControlLabel
                      control={
                        <Switch
                          checked={checked}
                          onChange={handleChange}
                          inputProps={{ "aria-label": "controlled" }}
                          sx={{ ml: { lg: 6, md: 4, xs: 2 } }}
                        />
                      }
                      label={
                        <span
                          style={{
                            color: "#01008B",
                            fontWeight: 500,
                            fontSize: 14,
                          }}
                        >
                          Status
                        </span>
                      }
                      labelPlacement="start"
                    />
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  {imagePreviewUrl && (
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      <Box
                        component="img"
                        src={imagePreviewUrl}
                        alt="Current Advertisement"
                        sx={{
                          width: { lg: 400, md: 300, xs: 300, sm: 350 },
                          height: 195,
                          // objectFit: "contain", // optional
                        }}
                      />
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      //   px: 1,
                      //   pt: "4px",
                      //   pb: "4px",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#01008B",
                        fontWeight: "600",
                        fontSize: "11px",
                      }}
                    >
                      Advertisement Entry date : 02-April-2025
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Divider
              sx={{
                borderColor: "#01008B",
                borderBottomWidth: 1.6,
                mb: 2,
              }}
            />
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Button
                onClick={handleSubmit}
                variant="contained"
                sx={{ width: "60%", mb: 1 }}
              >
                Update
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
